import { Component } from '@angular/core';

@Component({
  selector: 'app-new-roof-cost-trust-signals',
  standalone: true,
  imports: [],
  templateUrl: './new-roof-cost-trust-signals.component.html',
  styleUrl: './new-roof-cost-trust-signals.component.scss',
})
export class NewRoofCostTrustSignalsComponent {}
